import React, { useEffect, useState } from 'react';
import { Box, Card, CardHeader, Grid, Hidden, Link, Typography } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Footer from "../footer/Footer";
import NewCaseHeader from '../newcase/NewCaseHeader';
import { getThemeForEfa } from './../themes/theme.service';
import { DescriptionOutlined } from '@material-ui/icons';


const InformationDocumentsList = ({ match }) => {
    const [themeData, setThemeData] = useState(null);
    const [sourceId] = useState(match.params.sourceId);

    const getTheme = async () => {

        const data = await getThemeForEfa(sourceId);

        setThemeData(data);
    }

    const getPdfUrl = (systemDocumentType) => {
        return `${process.env.REACT_APP_API_HOST || ''}/publicapi/download/customer/document/${systemDocumentType}`;
    }

    const buildDownloadDocumentCard = (systemDocumentName, label) => {
        return <Link href={getPdfUrl(systemDocumentName)}
            target='_blank' >
            <Card style={{ width: '330px' }}>
                <CardHeader avatar={<DescriptionOutlined />} title={label} />
            </Card>
        </Link>;
    }

    useEffect(() => {
        getTheme();

    }, []);

    return themeData ? (
        <MuiThemeProvider theme={themeData.theme}  >
            <NewCaseHeader url={'/'} title="Dokumente" c2c={{}} isc2c={false}
                logoPath={themeData.logoPath} />

            <Box height='calc(100vh - 110px)' minHeight={'600px'} >

                <Box display='flex' padding={4} justifyContent='center' >
                    <Typography variant='h3'>Wichtige Dokumente & Rechtliche Hinweise</Typography>
                </Box>

                <Hidden smDown >
                    <Box padding={10} />
                </Hidden>

                <Grid container spacing={5} justify='center' >
                    <Grid item  >
                        {buildDownloadDocumentCard('NOTES_ON_DATA_PROCESSING', 'Hinweise zur Datenverarbeitung')}
                    </Grid>
                    <Grid item  >
                        {buildDownloadDocumentCard('CANCELLATION_POLICY', 'Widerrufsrecht')}
                    </Grid>
                    <Grid item  >
                        {buildDownloadDocumentCard('CUSTOMER_INFORMATION', 'Kundeninformationen')}
                    </Grid>
                    <Grid item  >
                        {buildDownloadDocumentCard('AGB', 'AGB')}
                    </Grid>
                </Grid>

            </Box>

            <Footer />
        </MuiThemeProvider>
    ) : '';

};

export default InformationDocumentsList;